import React from 'react'

import Header from '../../components/header/index.js'
import Footer from '../../components/footer/index.js'
import ManualFileUpload from '../../components/manualFileUpload/index.js'

const UploadManualFile = () => {

    return (
        <div>
            <Header />

            <ManualFileUpload />

            <Footer />
        </div>
    );
}

export default UploadManualFile;